import { NumberRangeFormatValidator } from '@models/validators/number-range-format.validator';
import { IsDefined, IsNotEmpty, IsString, MaxLength, IsNumber, Validate, IsBoolean, IsOptional, Allow } from 'class-validator';

/**
 * API model for number range creation and updates
 * This model is used for sending data to the API
 * Follows the C# model: Brz365.CDF.CoreElement.APIModel.APIModels.NumberRangeApiModel
 */
export class NumberRangeApiModel {
  /**
   * The scope/context where this number range applies
   * Required field
   */
  @IsString()
  @IsDefined()
  @IsNotEmpty()
  scope!: string;

  /**
   * The name of the number range
   * Required field, max length 255
   */
  @IsString()
  @IsDefined()
  @MaxLength(255)
  @IsNotEmpty()
  name!: string;

  /**
   * The format for the number range
   * Required field, max length 20
   * Must contain 15 or fewer '#' symbols
   */
  @IsString()
  @IsDefined()
  @MaxLength(20)
  @IsNotEmpty()
  @Validate(NumberRangeFormatValidator)
  format!: string;

  /**
   * Optional organization ID; null for cross-organization (global) number ranges
   */
  @Allow()
  @IsOptional()
  organizationId?: string | null;

  /**
   * Whether this number range is shared across all organizations
   */
  @IsBoolean()
  @IsOptional()
  isCrossOrganizationData?: boolean = false;

  /**
   * Whether to reset the last number used
   */
  @IsBoolean()
  @IsOptional()
  resetLastNumberUsed: boolean = false;

  /**
   * The last number that was used in this range
   */
  @IsNumber()
  @IsDefined()
  lastNumberUsed: number = 0;
}
